"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CompanyIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="246861" id="overview" className="py-16 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`flex flex-col lg:flex-row gap-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="lg:w-1/2">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground leading-tight">
              Kendall Home Inspection Experts
            </h2>
          </div>

          {}
          <div className="lg:w-1/2 flex flex-col gap-8">
            <p className="text-base md:text-lg text-muted-foreground font-default leading-relaxed">
              Providing comprehensive property assessments for Kendall homeowners and buyers. Our certified inspectors utilize advanced technology to deliver detailed reports on structural integrity, electrical systems, and potential hazards. We pride ourselves on local expertise, ensuring every South Florida property meets the highest safety standards. From pre-purchase inspections to wind mitigation, we offer the clarity you need to make informed real estate decisions with absolute confidence.
            </p>
            <div className="w-full">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/kendall_property_inspection.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/kendall_property_inspection.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/kendall_property_inspection.png-wvc-sizes" alt="Professional home inspection in Kendall Florida" className="w-full h-auto object-cover rounded-lg shadow-lg" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}